import script from "./BuzzDashNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BuzzDashNav.vue?vue&type=script&setup=true&lang=js"

import "./BuzzDashNav.vue?vue&type=style&index=0&id=6ee2c517&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee2c517"]])

export default __exports__